import React, { useState } from "react";
import config from "../../../config";

interface ForgotPasswordFormProps {
  setForgotPassword: (value: boolean) => void;
}

const ForgotPasswordForm: React.FC<ForgotPasswordFormProps> = ({
  setForgotPassword,
}) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [formMessage, setFormMessage] = useState({
    message: "",
    isError: false,
  });

  const handleForgotPassword = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch(
        `${config.API_BASE_URL}password_reset_request/`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email }),
        }
      );

      if (response.ok) {
        setFormMessage({
          message:
            "Thank you! If an account matches the email you provided, a password reset link will be sent to your email.",
          isError: false,
        });
      } else if (response.status === 429) {
        setFormMessage({
          message:
            "Error! You've requested a password reset too many times too quickly. Please check your email or wait 30 minutes to request a new one.",
          isError: true,
        });
      } else {
        setFormMessage({
          message:
            "Error sending reset link. Try again. If this error continues, please contact our support.",
          isError: true,
        });
      }
    } catch {
      setFormMessage({
        message: "Something went wrong. Please try again later.",
        isError: true,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleForgotPassword}>
      <div className="mb-3">
        <input
          type="email"
          className="login-page-form-control"
          placeholder="Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
      </div>
      {formMessage.message && (
        <p className={formMessage.isError ? "text-danger" : "text-success"}>
          {formMessage.message}
        </p>
      )}
      <button type="submit" className="btn login-page-btn" disabled={loading}>
        {loading ? "Sending..." : "Send Reset Link"}
      </button>
      <p className="mt-3">
        <a
          href="#"
          onClick={() => setForgotPassword(false)}
          className="login-page-switch-link"
        >
          Back to Login
        </a>
      </p>
    </form>
  );
};

export default ForgotPasswordForm;
